const members = [
  {
    name: "Cătălin Anghel",
    slug: "catalin-anghel",
    roles: [
      {
        type: "organizer",
        category: "we",
      },
      {
        type: "organizer",
        category: "you",
      },
      {
        type: "organizer",
        category: "v",
      },
    ],
    links: [
      "https://anghelbrothers.ro/",
      "https://www.facebook.com/AnghelBrothers/"
    ],
    seoDescription: `Cătălin Anghel este organizator în cadrul ediției din 2021 a Imagine Timisoara Festival. Vino să-l întâlnești!`,
    description: [
      {
        type: 'quoteParagraph',
        value: `"Fotografii au super-puteri. Putem să oprim timpul, să îl punem în ramă și să îl păstrăm acolo pentru totdeauna. Un fotograf oferă oamenilor posibilitatea de a călători în timp. Ori de câte ori te uiți la o fotografie, poți să te întorci în timp și să retrăiești în acel moment. Creativitatea nu are limite!"`,
      },
      {
        type: 'paragraph',
        value: `Cătălin Anghel este un artist fotograf și foto-jurnalist profesionist de nunți, cu sediul în Timișoara, România. A găsit cel mai bun coechipier în persoana fratelui său, Adrian Anghel. Ei lucrează împreună, începând din 2014, într-un duo fotograf-videograf cunoscut sub numele de Anghel Brothers, creând amintiri minunate pentru cuplurile din întreaga lume.`,
      },
      {
        type: 'paragraph',
        value: `Cătălin a pus bazele formării sale la Institutul de Fotografie din Dublin și și-a continuat educația prin intermediul mai multor cursuri și ateliere de lucru predate de nume grele din domeniul fotografiei și videografiei.`
      },
      {
        type: 'paragraph',
        value: `După ce s-a întors în țară în 2014, a simțit că locul de muncă din mass-media nu-i permitea să-și exprime pe deplin creativitatea, moment în care și-a lansat cariera independentă în fotografierea și filmarea de eveniment, fondând brandul propriu, Anghel Brothers, alături de Adrian. Cei doi artiști sunt foarte apreciați și respectați în comunitatea națională și internațională.`
      },
      {
        type: 'paragraph',
        value: `Anii de lucru ca jurnalist la televiziuni locale și naționale i-au modelat stilul fotografic. Lui Cătălin Anghel îi place să surprindă evenimentele într-un stil fotojurnalistic și folosește un stil strobist atunci când face fotografii de produs și de modă.`
      },
      {
        type: 'paragraph',
        value: `Cătălin Anghel este câștigătorul a numeroase premii naționale și internaționale de la toate concursurile importante la care a participat, organizate de: Fearless Photographers, WPS, MyWed, YPWP, WedInspire, WeddCamp. El a fost publicat de două ori de National Geographic. Prima sa expoziție cu fotografie de nuntă (30 lucrări) a avut loc la Salina Turda.`
      },
      {
        type: 'paragraph',
        value: `Pe lângă faptul că este un artist realizat, Cătălin Anghel este de asemenea un promotor foarte activ al cauzelor sociale legate de comunitatea. În 2014, a organizat un proiect de fotografie numit Fotocultura care a evidențiat orașul său natal, Timișoara.`
      }
    ],
  },

  {
    name: "Ana Maria & Daniel Dumbravă",
    slug: "ana-maria-daniel-dumbrava",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "dinamism_in_fotografia_de_eveniment"
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "cutezanta_si_dinamism_in_fotografia_de_eveniment"
        ],
      },
    ],
    links: [
      "https://fotodumbrava.ro/",
      "https://www.facebook.com/FotoDumbrava"
    ],
    seoDescription: `Ana Maria și Daniel Dumbravă sunt speakeri și traineri la Imagine Timisoara Festival 2021. Vino să-i întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Ana și Daniel s-au cunoscut fix pe stradă, la început de ianuarie: el, în mijlocul unui proiect, agitat și pus pe treabă; ea, cu căștile în urechi, calmă și sigură pe sine. Așa au rămas până azi, într-o relație de peste 13 ani - el cutezător, ea echilibrată. Prieteni, îndrăgostiți, soț și soție, tată și mamă într-o continuă căutare a răbdării pentru cei doi băieți-cucuieți, Daniel și Ana au “supraviețuit” împreună, construind și menținând la cote decente un business de familie."
      },
      {
        type: "paragraph",
        value: "Fotografia lor de eveniment a luat naștere dintr-un orgoliu, care s-a dovedit a fi, ulterior, o decizie înțeleaptă atât pentru dezvoltarea lor, cât și pentru bucuria zecilor de clienți mulțumiți. Se pricep cel mai bine la oameni în momentele lor fericite. Logodna, nunta, botezul și derivatele acestor tipuri de evenimente îi scot cel mai bine în evidență, le pun în valoare curajul, munca, perseverența și aptitudinile foarte bune de socializare."
      },
      {
        type: "paragraph",
        value: "Nu se consideră fotografi înnăscuți, nu au rețete de succes sau ași în mânecă pe care îi scot la evenimente ca să reușească să tragă cadre minunate, ci pur și simplu sunt implicați 101% în ceea ce fac. Ana și Daniel le sunt foarte recunoscători tuturor oamenilor pe care i-au întâlnit și tuturor comunităților din care fac parte, simțind încontinuu o îmbunătățire a standardelor fotografiei din punct de vedere al artei, cât și al raporturilor dintre oameni."
      }
    ],
  },
  {
    name: "Norbert Gubincsik",
    slug: "norbert-gubincsik",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "drone_photography"
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "estetica_uratului",
        ],
      },
    ],
    links: [
      "https://www.ng-media.ro/",
      "https://www.facebook.com/norbert.gubincsik.photography/"
    ],
    seoDescription: `Norbert Gubincsik este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Norbert este fotograf de evenimente de 10 ani, iar în tot acest timp a învățat că o compoziție bună se poate realiza în orice locație. Îi place să se considere o persoană simplă, să nu-și creeze așteptări și să-și folosească creativitatea. Comunicarea cu mirii i se pare foarte importantă, iar momentele de \"slow down\" din timpul nunții le consideră un atu important în găsirea cadrelor perfecte și a luminii."
      }
    ],
  },
  {
    name: "Elena Haralabaki",
    slug: "elena-haralabaki",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "understand_the_structure_of_a_wedding_event_capture_moments_creatively_and_master_the_art_of_storytelling"
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "how_can_we_take_great_photos_constantly",
        ]

      }
    ],
    links: [
      "https://www.elenaharalabaki.com/",
      "https://www.facebook.com/photoshootstudio1"
    ],
    seoDescription: `Elena Haralabaki este speaker și trainer la Imagine Timisoara Festival 2021. Vino să o întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Elena Haralabaki este fotograf de nuntă din anul 2010. Fotografia reprezintă o pasiune pentru ea încă de la o vârstă fragedă. Astfel, Elena a obținut licența în fotografie la Universitatea din Atena și diploma de master la Școala Superioară de Arte Plastice din Veneția. Acum, este mândră să se numere printre cei mai premiați fotografi de nuntă din lume și să facă parte din cele mai bune asociații de fotografie de nuntă. Elena s-a clasat pe locul 2 la concursul This is Reportage din 2019, în Top 10 Fearless Photographers 2019, în Top 10 WPS 2019, în Top 10 Photographers in AG | WPJA 2019. Elena a fost speaker la Inspiration Conference 2019, la Fearless Conference 2020 și la Photoschool Conference 2020 în Bulgaria. Fotografia pentru ea este în mod clar un limbaj, așa că îi place să creeze imagini care să aibă ceva de spus!"
      },
    ],
  },
  {
    name: "Victor Lax",
    slug: "victor-lax",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "what_is_your_project_as_a_photographer"
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "wedding_photography_doesnt_exist"
        ],
      },
    ],
    links: [
      "www.victorlax.net",
      "https://www.fearlessphotographers.com/top-wedding-photographers-in-the-world.cfm",
      "https://www.telecinco.es/informativos/cultura/fotografo-bodas-espanol-mejor-mundo_2_2348880094.html",
      "https://www.antena3.com/noticias/sociedad/el-mejor-fotografo-de-bodas-es-espanol_2017042058f90f3e0cf2461b6ddf3399.html",
      "https://www.youtube.com/watch?v=VpN3LQY6NUM",
    ],
    seoDescription: `Victor Lax este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Pentru Victor, fotografierea nunților reprezintă mai mult decât fotografierea momentelor-cheie: aruncarea orezului, primul dans, schimbul de verighete etc.. A fotografia nunta pentru el înseamnă a spune povești, povești despre oameni, oameni care acționează și interacționează ca oameni. El alege să se concentreze asupra lucrurilor mici și mari în egală măsură, considerând că scopul său ca fotograf este să interpreteze fiecare dintre aceste momente în felul său. Aceasta nu înseamnă că nu fotografiază momentele grozave ale nunții, dar își canalizează toată energia în captarea acelor momente care se întâmplă cu câteva secunde înainte sau câteva secunde după momentul-cheie. Victor îi încurajează pe colegii de breaslă să-și descopere identitatea de fotografi și să știe ce anume urmăresc în ziua nunții."
      },
      {
        type: "paragraph",
        value: "Víctor Lax s-a născut în 1979 într-un mic sat din provincia Huesca (în nordul Spaniei). Curând, s-a mutat la Zaragoza pentru a-și continua studiile fotografice. Odată finalizate, și-a început cariera de fotoreporter în Aragon. În următorii zece ani, a făcut cunoștință cu cele mai importante ziare și agenții locale, cum ar fi Agencia EFE sau Heraldo de Aragon."
      },
      {
        type: "paragraph",
        value: "În prezent, Victor continuă să participe la workshopuri avansate de fotografie la CTA (Zaragoza, Spania), oferindu-i o cunoaștere vastă despre fotografie și noua eră digitală."
      },
      {
        type: "paragraph",
        value: "Abia în 2009, Victor a cunoscut lumea fotografiei de nuntă, când a fost invitat de mai mulți colegi să-și aplice cunoștințele de fotoreporter aici. Foarte curând a fost cucerit de această nouă lume și a descoperit că există alte stiluri de fotografii de nuntă față de cele clasice. Nimic forțat sau artificial, nimic care ar putea să distorsioneze momentele unei zile speciale pentru doi oameni."
      },
      {
        type: "paragraph",
        value: "În prezent, Víctor fotografiază nunți în întreaga lume și combină aceasta cu activitatea de predare, oferind seminarii și workshopuri în multe țări diferite, cum ar fi: Mystic Seminars (EEUU), Silk Festival (India), Master Class Photographers (Mexic), Conferința Fearless Europe (Ungaria), Anfm Convention (Italia), Peps (Franța), Ninedots (Marea Britanie), Efti (Spania) și multe altele."
      },
      {
        type: "paragraph",
        value: "Recent, Victor a fost numit pentru a treia oară Fotograful Anului de către prestigioasa asociație globală de nunți Fearless Photographers."
      },
    ],
  },
  {
    name: "Ovidiu Leșan",
    slug: "ovidiu-lesan",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "cum_sa_nu_ai_un_mindset_de_fotograf_ratat",
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "frica_are_si_ea_curajul_ei",
        ],
      },
    ],
    links: [
      "https://www.ovidiul.ro/",
      "https://www.facebook.com/ovidiu.lesan.photographer",
    ],
    seoDescription: `Ovidiu Leșan este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Ovidiu fotografiază evenimente de 12 ani. A crescut simplu, a studiat alte domenii până ce și-a descoperit, din întâmplare, pasiunea pentru fotografie, căreia a ales să i se dedice. Iar acum își dorește ca, la rândul său, să-i ajute și pe alții să reușească în acest domeniu."
      },
      {
        type: "paragraph",
        value: "“Fii cea mai bună versiune a ta” nu sunt doar niște simple pentru Ovidiu, ci sunt crezul său - în fiecare zi, el învață să fie cea mai bună versiune a sa ca om, soț, tată, fotograf."
      },
      {
        type: "paragraph",
        value: "Prin participarea sa la Imagine Timisoara Festival, Ovidiu va încerca să le ofere participanților o busolă pentru momentele când simt că se rătăcesc, o soluție pentru atunci când nu mai au inspirație și o doză sănătoasă de curaj pentru momentele dificile."
      },
    ],
  },
  {
    name: "Cafa Liu",
    slug: "cafa-liu",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "dig_extraordinary_out_of_the_ordinary"
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "take_extraordinary_photos_from_ordinary_weddings"
        ],
      },
    ],
    links: [
      "https://cafaphoto.com/",
      "https://www.facebook.com/Cafaphoto"
    ],
    seoDescription: `Cafa Liu este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Cafa Liu este un fotograf de nuntă care capturează evenimentul în stil realist, dar din propriul său punct de vedere. Aceasta a dus la conturarea unui stil unic și personal al său: Cafa Style, un amestec de artă și documentar. Fotografia este mult mai mult decât o slujbă pentru Cafa. Camera îl ajută să întâlnească cupluri uimitoare de pe tot cuprinsul lumii. Cafa iubește fotografia chiar mai mult decât o bere bună :)"
      },
      {
        type: "paragraph",
        value: "Este unul dintre cei mai buni fotografi de eveniment din lume. Printre titlurile din palmaresul său, Cafa deține un loc în top 10 Fearless Photographers în 2016/2017/2018/2019 și top 10 ISPWP 2016/2017/2018/2019."
      },
    ],
  },
  {
    name: "Vlad Lodoaba",
    slug: "vlad-lodoaba",
    roles: [
      {
        type: "speaker",
        category: "we",
        events: [
          "daca_maine_ar_disparea_fotografia_de_nunta_nimeni_nu_ar_suferi"
        ],
      },
    ],
    links: [
      "https://vibecollector.com/",
      "https://www.facebook.com/vibecollector",
    ],
    seoDescription: `Vlad Lodoabă este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Vlad Lodoabă a pus mâna pe aparatul foto prima dată în perioada când fotografia pe film se numea doar „fotografie”. Când era mic, după ce a visat să fie ninja când crește mare, a revenit cu picioarele pe pământ și și-a dorit să ajungă fotograf de război, descoperind World Press Photo, fotografia de presă și imaginile explicite din războiul din Iugoslavia."
      },
      {
        type: "paragraph",
        value: "A lucrat o perioadă în presă, ca fotograf și editor foto, și încă se gândește cu melancolie la luptele de stradă pe care le-a fotografiat, la nopțile petrecute în Belgrad la declararea independenței provinciei Kosovo, la protestele fotografiate în Londra sau București din 2008 până în prezent și la pachetele de țigări sudate cu colegi de breaslă în fața penitenciarelor așteptând cadre cu persoane atunci faimoase, acum uitate, intrând sau ieșind din arest."
      },
      {
        type: "paragraph",
        value: "Totuși, pentru că socotelile de acasă nu se potrivesc cu cele de la târg, a ajuns încet-încet la fotografia de nuntă. Cu fotografia de nuntă a descoperit că indiferent de genul fotografic abordat, o fotografie bună este o fotografie bună."
      },
      {
        type: "paragraph",
        value: "În cei peste 10 ani de fotografie de nuntă, a fotografiat evenimente pe 4 continente în peste 10 țări, a fost în topurile celor mai cunoscute organizații internaționale și a jurizat concursuri interne și internaționale. Se consideră meșteșugar, nu artist fotograf, și pune preț pe momente bine surprinse, pe importanța compoziției și a luminii și pe editarea simplă care potențează un cadru deja puternic la declanșare."
      },
    ],
  },
  {
    name: "Alexandru Lupașcu",
    slug: "alexandru-lupascu",
    roles: [
      {
        type: "speaker",
        category: "we",
        events: [
          "momentele_care_ne_definesc"
        ],
      },
    ],
    links: [
      "www.lupascuphoto.com",
      "www.facebook.com/lupascuphoto",
      "www.instagram.com/lupascuphoto"
    ],
    seoDescription: `Alexandru Lupașcu este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Pasionat de fotografie încă din 2006 și dedicat fotografiei de nuntă din 2014, Alexandru știe sigur că și-a găsit vocația pentru tot restul vieții."
      },
      {
        type: "paragraph",
        value: "Iubește să lucreze cu lumina și în special cu cea dură, aceea de la prânz. Iubește umbrele, adâncimea, culorile puternice și contrastul, îi place să vadă cuplul râzând, ceea ce deseori îl molipsește, pentru că, înainte de toate, iubește viața."
      }
    ],
  },
  {
    name: "Julius Paul",
    slug: "julius-paul",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "fotografie_si_text_pe_instagram",
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "storytelling_in_social_media_marketing"
        ],
      },
    ],
    links: [
      "https://juliuspaul.com/",
      "https://www.facebook.com/juliuspaulcom",
    ],
    seoDescription: `Julius Paul este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Julius Paul simte că face fotografie dintotdeauna. Tatăl său a fost fotograf, iar el a crescut printre aparate, filme, revelatoare și fixatoare foto. Mereu i-a plăcut să vorbească și să asculte povești, mereu cu un ochi ațintit la liniile care creează simetrii și armonie în natură. La 17 ani, a decis că ceea ce urma să facă în viață trebuie în primul rând să îi placă, să ajute oamenii și să lase o moștenire. Și astfel, deși nu a acordat o importanță deosebită fotografiei la început, a ajuns să facă o carieră din asta. A urmat cursurile Universității de Artă și Design din Cluj-Napoca, secția Foto-Video, la nivel de licență, master și doctorat, pentru a deveni cât mai bun în acest domeniu."
      },
      {
        type: "paragraph",
        value: "Acum, după 12 ani de experiență în domeniul fotografiei de eveniment, a ajuns la concluzia că, pe lângă tehnică, tehnologie, cromatică, perspectivă și armonie, povestea este cea care contează cu adevărat."
      },
    ],
  },
  {
    name: "Marian Sterea",
    slug: "marian-sterea",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "perfectiunea_nu_atrage_atentia",
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "fucked_up_stories"
        ],
      },
    ],
    links: [
      "https://www.mariansterea.ro/",
      "https://www.facebook.com/mariansterea.ro",
    ],
    seoDescription: `Marian Sterea este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Marian Sterea este co-fondator al celei mai importante comunități de fotografi de nuntă și evenimente din România, Weddcamp Community. Este, de asemenea, unul dintre inițiatorii 2CreativeWorkshop, iar în momentul de față este Sony Europe Imaging Ambassador."
      },
      {
        type: "paragraph",
        value: "Apreciat pentru măiestria cu care lucrează cu lumina naturală, dar și cu cea artificială, pentru a scoate portrete de poveste, Marian Sterea a fost remarcat și peste hotare, unde și-a prezentat munca și stilul fotografic de-a lungul anilor în cadrul workshopurilor și conferințelor în țări precum: Anglia, Cuba, Germania, Italia, Grecia, Turcia, Macedonia de Nord, Serbia, Bulgaria, Rep. Moldova etc."
      },
      {
        type: "paragraph",
        value: "Cum se prezintă Marian Sterea pentru cei care nu îl cunosc?"
      },
      {
        type: "quoteParagraph",
        value: "Iubesc fotografia, iubesc să transform momentele acelea imperfecte în emoții perfecte. Și iubesc să lucrez cu lumina și cu OAMENII din jurul meu. Pentru mine fotografia nu este despre cele mai scumpe sau noi camere."
      },
      {
        type: "quoteParagraph",
        value: "Altminteri, banii ii investesc cu drag în echipamente, mai ales dacă e vorba despre lumini. Pentru mine, chiar și astăzi, rămân valabile cuvintele lui Annabel Williams: <Fotografia este 90% psihologie și 10% tehnică>."
      },
      {
        type: "paragraph",
        value: "Premii:"
      },
      {
        type: 'unorderedList',
        value: [
          `Image of the year 2012 – Nikon Romania`,
          `Top 50 Fearless Photographers 2013`,
          `17 premii Fearless Photographers`,
          `20 premii ISPWP`,
          `TOP 20 SPRING 2016 ISPWP`,
          `28th in TOP 100 ISPWP 2016`,
          `Multiple premii la Wedding & Portrait Photography International – WPPI`,
          `Master Photographers Association, premiul “Aspiring member” 2016/17 MPA UK`,
          `Locul 8 în top 100 Wedding Photographer Society`,
          `Top 150 best international wedding photographers for 2016 SLR Lounge`,
        ]
      },
    ],
  },
  {
    name: "Florin Ștefan",
    slug: "florin-stefan",
    roles: [
      {
        type: "trainer",
        category: "we",
        events: [
          "atitudinea_unui_profesionist_in_ziua_evenimentului_povestea_unui_eveniment",
        ],
      },
      {
        type: "speaker",
        category: "we",
        events: [
          "relationarea_si_comunicarea_in_fotografia_de_nunta"
        ],
      },
    ],
    links: [
      "http://florinstefan.ro/",
      "https://www.facebook.com/florinstefan.ro",
    ],
    seoDescription: `Florin Ștefan este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: `Florin a început să fie prezent pe scenele conferințelor de fotografie din România în 2018. A participat la Weddingstories Cluj 2018, 2019, la Shootless 2019 și la Forum Conference 2019 în Bulgaria, la Nessebar. Tot în 2019 i s-a propus să fie formator la cursurile foto ale celor de la DallesGO și nu a stat pe gânduri - a răspuns "prezent", iar acum se bucură de o grupă de oameni frumoși, pe care îi învață atât fotografie, cât mai ales cum trebuie să fie parte a unei comunități și nu persoane care "șușotesc pe la colțuri".`
      },
      {
        type: "paragraph",
        value: "Pe plan internațional, a reușit din nou o clasare în primii 5 în topul WPS, o clasare în top 100 ISPWP (locul 52) și a primit 3 premii Fearless Photographers - unele din cele mai grele competiții de fotografie de nuntă din lume."
      },
    ],
  },
  {
    name: "Ioan Braghesiu",
    slug: "ioan-braghesiu",
    style: "Produs",
    roles: [
      {
        type: "trainer",
        category: "you",
        events: [
          "content_marketing_un_nou_model_de_business_pentru_fotografi_si_videografi",
        ],
      },
      {
        type: "speaker",
        category: "you",
        events: [
          "fotografie_de_produs_pandemia_digitalizării_de_la_petreceri_de_nunta_la_marketing_online"
        ],
      },
    ],
    links: [
      "https://vizibil.eu/",
      "https://www.facebook.com/vizibil.eu",
    ],
    seoDescription: `Ioan Braghesiu este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: `La cei 32 de ani ai săi, Ioan Braghesiu se ocupă de fotografie de aproape 12 ani. Pasionat de tehnologie și de lumea web, este o persoană tehnică și foarte tipicară la detalii. Are un istoric de 10 ani în fotografia de eveniment, iar în fotografia comercială și de produs, are o experiență de mai bine de 5 ani.`
      },
      {
        type: "paragraph",
        value: `În ultimii 3 ani a lucrat foarte mult cu fotografie și video pentru conținut online, în special pentru zona de adware (campanii sponsorizate). Împreună cu colegul său Liviu Popica, a deschis primul studio acum 9 ani. De atunci, cei doi au un spațiu dedicat pentru muncă, mai ales că Ioan preferă să nu lucreze de acasă. Adoră să aibă colegi și angajați, să îi susțină, să îi ajute să se dezvolte și mai ales să conducă un colectiv. Preferă să fie un lider și nu un șef. Învață continuu, încearcă să se dezvolte, consumă zilnic multă informație și stă conectat online, în medie, aproximativ 5 ore pe zi. Poate spune cu fericire ca a găsit și următorul domeniu în care vrea să se dezvolte, și anume universul 3D, iar ca aplicație mai exactă, în realitatea virtuală și cea augmentată. Consideră că va lăsa deoparte aparatul de fotografiat și se va folosi mai departe doar de cunoștințele acumulate în acești ani.`
      }
    ],
  },
  {
    name: "Vlad Eftenie",
    slug: "vlad-eftenie",
    style: "Mobile",
    roles: [
      {
        type: "trainer",
        category: "you",
        events: [
          "urban_best_photospot_fotografia_de_observare_cu_telefonul_mobil"
        ],
      },
      {
        type: "speaker",
        category: "you",
        events: [
          "discursul_vizual_narativ_in_fotografia_cu_telefonul_mobil"
        ],
      },
    ],
    links: [
      "http://www.vladeftenie.ro",
      "https://www.instagram.com/veftenie/",
    ],
    seoDescription: `Vlad Eftenie este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Lector Dr. Arh. Vlad Eftenie este membru al asociaţiilor profesionale OAR și RUR. A semnat cercetarea doctorală cu subiectul “Fotografia, instrument metodic de studiu în planul imaginii urbane”. Este lector în cadrul departamentului Sinteza de Proiectare al UAUIM, titular al cursului teoretic “Fotografia ca instrument de studiu şi cunoaștere în arhitectură”. A absolvit UAUIM în 2003 şi Masterul franco-român de Dezvoltare Urbană Integrată în 2005."
      },
      {
        type: "paragraph",
        value: "Este autor şi co-autor al unor numeroase studii şi proiecte de arhitectură/urbanism în domeniile educaţiei, comercial, administrativ şi rezidențial, în colectivul agenţiei de arhitectură Baumarc Proiect. A publicat numeroase articole în reviste de specialitate având ca subiect arhitectura şi fotografia de arhitectură. Este autor/co-autor al unor numeroase expoziţii de fotografie urbană şi de arhitectură, atât în România (Bucureşti, Timişoara, Baia Mare, Negreşti-Oaş) cât şi în străinătate (Berlin, Lisabona, Toulouse, Padova, Dublin, Veneţia, Viena)."
      },
      {
        type: "paragraph",
        value: "A reprezentat România în cadrul EuroARTPhoto, expoziție cu participare internațională organizată de Ufficio Stampa sub patronajul Uniunii Europene, la Milano și Roma, în 2014-2015."
      },
      {
        type: "paragraph",
        value: "A iniţiat şi susţinut numeroase workshopuri şi ateliere de fotografie urbană/street/de arhitectură în Bucureşti, Cluj, Braşov, Botoşani, Constanţa. A participat la conferințele Festivalului Internațional de Psihanaliză și Film, ediția 2015. A fost membru în juriul Festivalului Filmul de Piatra, edițiile 2015 și 2019. A fost membru în echipa oficială de fotografi ai Festivalului Enescu, ediția 2015 și colaborator al Radio România Cultural în cadrul rubricii “Orașul vorbește”, din 2016."
      },
      {
        type: "paragraph",
        value: "A obținut un premiu în cadrul competiţiei internaţionale de fotografie urbană CBRE Urban Photographer of the Year, 2011. De asemenea, este câştigător al secţiunii Open Low Light din cadrul Sony World Photography Awards, 2014."
      },
      {
        type: "paragraph",
        value: "Vlad Eftenie a fost inclus în galeria “Forbes Heroes” de către publicația Forbes România, în 2016."
      },
    ],
  },
  {
    name: "Cătălin Muntean",
    slug: "catalin-muntean",
    style: "Glam/Fashion",
    roles: [
      {
        type: "trainer",
        category: "you",
        events: [
          "fotografie_high_fashion_si_beauty_workshop_avansat_de_photoshop_editare_high_end_glamour_si_beauty"
        ],
      },
      {
        type: "speaker",
        category: "you",
        events: [
          "fotografie_high_fashion_beauty"
        ],
      },
    ],
    links: [
      "www.airmanproduction.com",
      "https://www.facebook.com/catalinmunteanphotographer",
    ],
    seoDescription: `Cătălin Muntean este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Cătălin Muntean este un fotograf profesionist cu o experiență de peste 12 ani în domeniu,cu studii superioare realizate în cadrul facultății de Arte și Design din Timișoara. Deține un portofoliu variat, în cadrul acestuia regăsindu-se numeroase colaborări cu diverse reviste, vedete, modele, branduri naționale și internaționale."
      },
      {
        type: "paragraph",
        value: "Unul dintre cele mai importante proiecte derulate de Cătălin în prezent este revista erotică BeGudd Magazine, proiect ce s-a conturat și a evoluat substanțial în ultimul an, aceasta fiind singura revistă erotică din România în momentul de față."
      },
      {
        type: "paragraph",
        value: "Cuvântul cheie din spatele întregii sale dedicări pentru fotografiei este pasiunea, element ce stă la baza oricărui cadru realizat."
      },
      {
        type: "quoteParagraph",
        value: "I believe that small imperfections make a photograph perfect and I know that passion, desire and will make the photographer successful."
      },
    ],
  },
  {
    name: "Sorin Onișor",
    slug: "sorin-onisor",
    style: "Peisaj",
    roles: [
      {
        type: "trainer",
        category: "you",
        events: [
          "fotografie_etnografica_si_de_peisaj_satele_si_natura_care_le_inconjoara"
        ],
      },
      {
        type: "speaker",
        category: "you",
        events: [
          "fotografia_etnografica_si_de_peisaj_satele_si_natura_care_le_inconjoara"
        ],
      },
    ],
    links: [
      "https://www.sorinonisor.ro",
      "https://www.facebook.com/sorinonisor",
    ],
    seoDescription: `Sorin Onișor este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: "paragraph",
        value: "Sorin Onișor s-a născut în 10.04.1970, la Timișoara."
      },
      {
        type: "paragraph",
        value: "Studii:"
      },
      {
        type: "unorderedList",
        value: [
          "Doctorand al Universității de Vest Timișoara, 2008-2011",
          "Școala Populară de Artă, Timișoara, secția de fotografie, 2003-2005",
          "Masterat “Romanitate orientală”, Universitatea de Vest Timișoara, 1999-2001",
          "Universitatea de Vest Timișoara, Facultatea de Istorie, 1992-1997",
        ]
      },
      {
        type: "paragraph",
        value: "Expoziții personale:"
      },
      {
        type: "unorderedList",
        value: [
          "Casa Adam Muller Guttenbrunn, Timișoara, februarie 2005",
          "Librăria Joc Secund-Humanitas, Timișoara, martie 2006",
          "Iulius Mall, Timișoara, iulie 2006",
          "Romexpo, București, aprilie 2007",
          "Librăria Joc Secund-Humanitas, Timișoara, aprilie 2007",
          "Casa Artelor, Galeria Pygmalion, Timișoara, martie 2008",
          "Romexpo, București, octombrie 2008",
          "Chevereșu Mare, jud. Timiș, martie 2009",
          "Oradea, iulie 2010",
          "Iași, Copou, septembrie 2010",
          "Constanța, iulie 2011",
          "Iași, august 2011",
          "Pașcani, Casa de Cultură, septembrie 2011",
          "Suceava, octombrie 2011",
          "Brașov, ianuarie 2012",
          "Coreea de Sud, iulie 2012",
          "Timișoara, Universitatea de Vest, septembrie 2012",
          "Baden-Viena, aprilie 2013",
          "Tulcea, iunie 2013",
          "Drobeta Turnu Severin, iunie 2013",
          "Lyon, octombrie 2013",
          "Zaragoza, decembrie 2013",
          "București, Muzeul Antipa, decembrie 2013",
          "Bruxelles, februarie 2014",
          "Cernăuți, mai 2015",
          "Turda, mai 2015",
          "Torino, martie 2015",
          "Rimini, iulie 2015",
          "Japonia, august 2015",
          "București, septembrie 2015",
          "Gura Humorului, octombrie 2015",
          "București, noiembrie 2015",
          "Iași, noiembrie 2015",
          "Varșovia, decembrie 2015",
          "Zaragoza, decembrie 2015",
          "Bologna, aprilie 2016",
          "București, aprilie 2016",
          "Charleston, SUA, mai 2016",
          "Florența, iulie 2016",
          "Siena, august 2016",
          "Bucuresti, noiembrie 2016",
          "Londra, decembrie 2016",
          "Timișoara, mai 2017",
          "Paris, mai 2017",
          "Ploiești, septembrie 2017",
          "Doha, Quatar, noiembrie 2017",
          "Sibiu, noiembrie 2017",
          "Olanda, mai 2018",
          "Finlanda, septembrie 2018",
          "București, septembrie 2018",
          "Bruxelles, februarie 2019",
          "Copenhaga, martie 2019",
          "Vilnius, Lituania, martie 2019",
          "Ucraina, aprilie 2019",
          "Bruxelles, mai 2019",
          "China, iunie 2019",
        ]
      },
      {
        type: "paragraph",
        value: "Numeroase expoziții colective, în țară și străinătate."
      },
      {
        type: "paragraph",
        value: "Membru fondator și vicepreședinte al grupului fotografic F5,6 din Timișoara."
      },
      {
        type: "paragraph",
        value: "Autor, în colaborare cu Direcția pentru Cultură, Culte și Patrimoniu Cultural Național a județului Timiș și Mitropolia Banatului, a volumelor:"
      },
      {
        type: "unorderedList",
        value: [
          "“Biserica de la Poieni-icoana, istorie și semn”, 2005",
          "“Cărările credinței - biserici de lemn monument istoric din județul Timiș”, 2006",
        ]
      },
      {
        type: "paragraph",
        value: "Colaborator al Televiziunii Naționale în cadrul Proiectului “Oamenii deltei”, 2008, 2009 și 2010."
      },
      {
        type: "paragraph",
        value: "Autor, în colaborare cu fotograful Mihai Grigorescu, a albumului de fotografie “Maramureș - Oameni și locuri”, 2009"
      },
      {
        type: "paragraph",
        value: "Interviuri și fotografii în diverse reviste și publicații."
      },
      {
        type: "paragraph",
        value: "Organizator de workshopuri de fotografie în Maramureș, Bucovina, Delta Dunării, Sibiu, Giurgiu, Buzău, Prahova, Brașov, Mureș, Alba, Harghita, Iași, Timiș, Mehedinți, Caraș-Severin, Vâlcea, Argeș, București, în perioada 2009-2019."
      },
      {
        type: "paragraph",
        value: "Proiecte în derulare:"
      },
      {
        type: "unorderedList",
        value: [
          "Bisericile de lemn din sudul Transilvaniei și nordul Olteniei",
          "Fierarii și cărbunarii din Transilvania (teză de doctorat)",
          "Oamenii deltei, în colaborare cu Televiziunea Națională, 2008-2013",
          "“Pierduți în (dez)integrare”, dedicat comunității rome din România",
          "“Universul copilăriei în satul românesc contemporan”",
          "“Meșteșuguri tradiționale românești”",
        ]
      },
      {
        type: "paragraph",
        value: "Distincții:"
      },
      {
        type: "unorderedList",
        value: [
          "Marele Premiu în cadrul Salonului Național de Fotografie Turistică, București, octombrie 2006",
          "Premiul I la Salonul de fotografie etnografică, Cluj, octombrie 2006",
          "Premiul special “Victor Iliu”, Salonul de fotografie Buzău, octombrie 2006",
          "Finalist la Concursul “Fotoreportajul meu”, organizat de revista Descoperă, București, 2005, 2006, 2007, 2008.",
          "Finalist la Concursul organizat de Fondul ONU pentru populație, București, noiembrie 2006",
          "Premiul I, secțiunea fotoreportaj, la concursul de fotografie din cadrul festivalului IRAF, Timișoara, septembrie 2007",
          "Premiile II și III, în cadrul Salonului Național de Fotografie Turistică, București, octombrie 2007",
          "Finalist la Concursul de fotografie “Transilvania mea”, Sibiu, 2007",
          "Finalist la Salonul de fotografie etnografică, Cluj, decembrie 2007",
          "Marele Premiu și Premiul Juriului, în cadrul Salonului Național de Fotografie Turistică, București, martie 2008",
          "Finalist la Salonul de fotografie, Buzău, septembrie 2008",
          "Premiul I la Salonul de fotografie etnografică, Cluj, noiembrie 2008",
          "Mențiune specială la Orange „Together”, noiembrie 2008",
          "Premiile I și II în cadrul Salonului Național de Fotografie Turistică, București, martie 2009",
          "Premiul II, în cadrul Salonului Național de Fotografie Turistică, București, octombrie 2009",
          "Premiul I la Salonul de fotografie etnografică, Cluj, decembrie 2009",
          "Titlul de “Fotograful anului” și premiile I, II și III în cadrul secțiunii de fotojurnalism la salonul AAFR “Fotograful anului” ediția I, București, ianuarie 2010",
        ]
      },
      {
        type: "paragraph",
        value: "Membru în diverse jurii de specialitate, la concursurile naționale de fotografie."
      },
    ],
  },
  {
    name: "Daniela Sterea",
    slug: "daniela-sterea",
    style: "Newborn",
    roles: [
      {
        type: "trainer",
        category: "you",
        events: [
          "timeless_newborn_photography"
        ],
      },
      {
        type: "speaker",
        category: "you",
        events: [
          "fotografia_de_nou_nascut_in_stilul_propriu"
        ],
      },
    ],
    links: [
      "https://www.danielasterea.ro/",
      "https://www.facebook.com/danielasterea.ro",
    ],
    seoDescription: `Daniela Sterea este speaker și trainer la Imagine Timisoara Festival 2021. Vino să o întâlnești!`,
    description: [
      {
        type: "quoteParagraph",
        value: "Cred că liniștea interioară și mulțumirea vin din pasiunile pe care le cultivi."
      },
      {
        type: "quoteParagraph",
        value: "Poți cunoaște cu adevărat fericirea când reușești să faci din pasiunea ta un mod de viață."
      },
      {
        type: "quoteParagraph",
        value: "Într-o zi, am trecut pe lângă un magazin. În vitrina lui, mi-a făcut cu ochiul un ghem de lână, cu o culoare nespus de frumoasă. Cred că e bine uneori să te lași ghidat de impuls, așa că nu am stat prea mult pe gânduri și am cumpărat ghemul acela. Cum am ajuns însă acasă, m-am așezat în fața calculatorului și am uitat complet de mica mea descoperire. Avea să treacă ceva până când l-am regăsit. Și mai mult până să îi înțeleg rostul. Dar cu el a început totul. Ușor-ușor, am descoperit cât de mult îmi place să împletesc. Am tricotat cu drag cele mai delicate props-uri pentru micii clienți ai studioului nostru."
      },
      {
        type: "quoteParagraph",
        value: "Pasiunea mea pentru fotografie a crescut în timpul acesta. Iar dragostea pentru lucrurile tricotate s-a împletit cu fotografia pentru nou-născuți. Acum, uitându-ma în urmă, cred că în vitrina aceea am găsit de fapt, propriul fir al Ariadnei. Spun asta pentru ca din acel moment a început să se definească stilul meu de a fotografia nou-născuți. (Daniela Sterea)"
      },
    ],
  },
  {
    name: "Roman Burlaca",
    slug: "roman-burlaca",
    roles: [
      {
        type: "trainer",
        category: "v",
        events: [
          "productie_de_videoclip_de_la_a_la_z"
        ],
      },
      {
        type: "speaker",
        category: "v",
        events: [
          "music_video_un_instrument_in_mana_artistilor"
        ],
      },
    ],
    links: [
      "https://brfilms.ro/",
      "https://www.facebook.com/brfilms.ro",
    ],
    seoDescription: `Roman Burlaca este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: 'paragraph',
        value: `Roman Burlaca este un regizor basarabean, născut la Chișinău. În doar doi ani, a devenit unul dintre cei mai bine cotați regizori de videoclipuri din România și cel mai bine cotat din Republica Moldova. A deschis o casă de producție numită „BR Films”, care are în portofoliu peste 200 de producții video (clipuri, spoturi). Colaborează atât cu artiști naționali, cât și internaționali.`,
      },
      {
        type: 'paragraph',
        value: `Roman Burlaca face parte din proiectul Carla's Dreams încă de la începuturile acestuia, regizându-i practic toate videoclipurile. În toamna anului 2016, este nominalizat la videoclipul anului în România cu Carla's Dreams - "Te rog", precum și la Media Music Award 2016, reușind să-și adjudece premiul. În aceeași perioadă, reușește să bată recordul all-time de vizualizări pe Youtube România, acumulând cu videoclipul celor de la Carla's Dreams - “Imperfect” un milion de vizualizări în doar 23 de ore de la lansare.`,
      },
      {
        type: 'paragraph',
        value: `Cel mai vizionat video de pe YouTube în România este „Sub pielea mea” (85 de milioane de vizualizări), piesa care a fost locul 1 incontestabil pe radio și TV în România, în 2016, în regia lui Roman.`,
      },
      {
        type: 'paragraph',
        value: `A fost nominalizat pentru cel mai bun regizor, debut și best music video la câteva competiții din România, cât și din Republica Moldova. A primit diverse premii, printre care și „Omul Anului”, în Republica Moldova.`,
      },
      {
        type: 'paragraph',
        value: `Portofoliu:`
      },
      {
        type: 'video',
        value: `https://vimeo.com/351183717`
      },
    ],
  },
  {
    name: "Eduard Carp",
    slug: "eduard-carp",
    roles: [
      {
        type: "trainer",
        category: "v",
        events: [
          "construirea_si_importanta_filmului_de_nunta"
        ],
      },
      {
        type: "speaker",
        category: "v",
        events: [
          "tendinte_trend_si_accente_in_filmul_de_nunta"
        ],
      },
    ],
    links: [
      "https://eduardcarp.com/",
      "https://www.facebook.com/eduardcarpvideographer/",
    ],
    seoDescription: `Eduard Carp este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: 'paragraph',
        value: `Eduard activează în domeniul videografiei de peste 10 ani. Nu s-a afirmat prin concursuri, ci prin lucrările sale, care pun o amprentă asupra celui care le privește.`,
      },
      {
        type: 'paragraph',
        value: `Abordarea sa preferată este una jurnalistică - nimic înscenat, suprasolicitat sau artificial. Îi place să lucreze cu lumina naturală, încercând să redea un film cât mai curat și firesc.`,
      },
      {
        type: 'paragraph',
        value: `În ultimii doi ani, a organizat o serie de workshopuri și masterclass-uri în țară și în afara țării, unde de fiecare dată a oferit tot ceea ce a învățat în acești ani de activitate.`,
      },
      {
        type: 'paragraph',
        value: `Datorită muncii și a eforturilor depuse în ultimii ani, a devenit primul Brand Ambassador Panasonic România.`,
      },
      {
        type: 'paragraph',
        value: `Portofoliu:`
      },
      {
        type: 'video',
        value: `https://vimeo.com/388167903`
      },
      {
        type: 'video',
        value: `https://vimeo.com/368981647`
      }
    ],
  },
  {
    name: "Riccardo Fasoli",
    slug: "riccardo-fasoli",
    roles: [
      {
        type: "trainer",
        category: "v",
        events: [
          "workshop_de_cinematografie_de_nunta"
        ],
      },
      {
        type: "speaker",
        category: "v",
        events: [
          "keep_it_real"
        ],
      },
    ],
    links: [
      "https://www.kreativ-wedding.de",
      "https://www.instagram.com/kreativwedding/",
      "https://www.pinterest.de/kreativwedding/",
      "https://facebook.com/kreativwedding",
      "https://vimeo.com/riccardofasoli"
    ],
    seoDescription: `Riccardo Fasoli este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: 'paragraph',
        value: `S-a mutat în Germania din Italia în 2012 și a început, împreună cu soția sa Anne, aventura domeniul nunților.`
      },
      {
        type: 'paragraph',
        value: `Una dintre primele companii din Germania care a oferit fotografii și videoclipuri, Kreativ Wedding este, de asemenea, cunoscută în întreaga lume datorită unui număr mare de nunți de destinație și unui stil cinematografic al produselor video realizate de ei.`
      },
      {
        type: 'paragraph',
        value: `Portofoliu:`
      },
      {
        type: 'video',
        value: `https://vimeo.com/185822289`
      },
      {
        type: 'video',
        value: `https://vimeo.com/299925520`
      },
    ],
  },
  {
    name: "Evgeny Hollywood",
    slug: "evgeny-hollywood",
    roles: [
      {
        type: "trainer",
        category: "v",
        events: [
          "editing_process_color_grading_introduction"
        ],
      },
      {
        type: "speaker",
        category: "v",
        events: [
          "generation_of_ideas_and_implementation"
        ],
      },
    ],
    links: [
      "https://www.facebook.com/MVI-MEDIA-1437613639871538/"
    ],
    seoDescription: `Evgeny Hollywood este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: 'paragraph',
        value: `Evgeny Hollywood este câștigător multiplu al competițiilor internaționale și al premiilor WEVA, fiind autorul unui stil propriu al videoclipului de nuntă.`
      },
      {
        type: 'paragraph',
        value: `Portofoliu:`
      },
      {
        type: 'video',
        value: `https://vimeo.com/379796532`
      },
      {
        type: 'video',
        value: `https://vimeo.com/308000864`
      },
      {
        type: 'video',
        value: `https://vimeo.com/320745789`
      },
    ],
  },
  {
    name: "Raluca Rotund",
    slug: "raluca-rotund",
    roles: [
      {
        type: "trainer",
        category: "v",
        events: [
          "cum_sa_gasesti_inspiratia_in_lucrurile_simple_tehnici_de_filmare_si_editare"
        ],
      },
      {
        type: "speaker",
        category: "v",
        events: [
          "cum_sa_te_lasi_inspirat"
        ],
      },
    ],
    links: [
      "https://rotundperfect.ro/",
      "https://www.facebook.com/rotundperfect",
    ],
    seoDescription: `Raluca Rotund este speaker și trainer la Imagine Timisoara Festival 2021. Vino să o întâlnești!`,
    description: [
      {
        type: 'paragraph',
        value: `Raluca Rotund este fotograf de plăcere și, de vreo 3 ani, videograf de meserie (dar și pe aceasta tot cu plăcere o face). Nu îi place să povestească despre ea însăși și poate din pricina asta a ales să povestească despre alții. În ciuda faptului că nu credea că va ajunge să documenteze evenimente, a ajuns la concluzia că este foarte probabil ca pentru ea acesta să fie un dream job. Vede lucrurile foarte simplu, chiar dacă filmele sale (spun alții) sunt complicate și crede că cel mai important e să poți dărâma anumite bariere din interiorul tău ca să poți lăsa creativitatea să-și facă acolo cuib.`
      },
      {
        type: 'paragraph',
        value: `Portofoliu:`
      },
      {
        type: 'video',
        value: `https://vimeo.com/359635512`
      },
      {
        type: 'video',
        value: `https://vimeo.com/374800255`
      },
      {
        type: 'video',
        value: `https://vimeo.com/373342314`
      },
    ],
  },
  {
    name: "Dima Vutcariov",
    slug: "dima-vutcariov",
    roles: [
      {
        type: "trainer",
        category: "v",
        events: [
          "structura_filmului_lumina"
        ],
      },
      {
        type: "speaker",
        category: "v",
        events: [
          "importanta_sunetului_in_film_si_stilul_de_filmare"
        ],
      },
    ],
    links: [
      "http://dimavutcariov.com/",
      "https://www.facebook.com/vutcariovmd-1298804330198343",
    ],
    seoDescription: `Dima Vutcariov este speaker și trainer la Imagine Timisoara Festival 2021. Vino să-l întâlnești!`,
    description: [
      {
        type: 'paragraph',
        value: `Dima Vutcariov activează în industria nunților de 9 ani, 5 dintre care i-a acordat videografiei.`
      },
      {
        type: 'paragraph',
        value: `De mic copil a început să studieze arta. La vârsta de 10 ani, a absolvit Școala de Arte din orașul său natal, Ialoveni. A absolvit studiile superioare în domeniul multimedia la Academia de Muzică, Teatru și Arte Plastice din Republica Moldova.`
      },
      {
        type: 'paragraph',
        value: `Întrebat ce anume îl inspiră, răspunsul lui Dima include sentimentele și schimbarea de orice fel, pe care o intuiește în felul său. Locul în care se desfășoară filmările are o conotație deosebită. Culege momentele și le atribuie unei amintiri pe vecie.`
      },
      {
        type: 'paragraph',
        value: `Îl inspiră traiectoriile, mersul, deplasarea. Îl inspiră tot ce a fost și tot ce simte.`
      },
      {
        type: 'paragraph',
        value: `Portofoliu:`
      },
      {
        type: 'video',
        value: `https://vimeo.com/365448629`
      },
      {
        type: 'video',
        value: `https://vimeo.com/368018633`
      },
      {
        type: 'video',
        value: `https://vimeo.com/378997887`
      },
    ],
  },
];

module.exports.useMembers = () => {
  return members;
};

module.exports.useTrainers = () => {
  return this.useMembers().filter(member => member.roles.find(role => role.type === "trainer"));
};

module.exports.useOrganizers = () => {
  return this.useMembers().filter(member => member.roles.find(role => role.type === "organizer"));
};

module.exports.useWemembers = () => {
  return members.filter(member => member.roles.find(role => role.category === 'we'));
};

module.exports.useWespeakers = () => {
  return this.useWemembers().filter(member => member.roles.find(role => role.type === "speaker"));
};

module.exports.useWetrainers = () => {
  return this.useWemembers().filter(member => member.roles.find(role => role.type === "trainer"));
};

module.exports.useYoumembers = () => {
  return members.filter(member => member.roles.find(role => role.category === "you"));
};

module.exports.useYouspeakers = () => {
  return this.useYoumembers().filter(member => member.roles.find(role => role.type === "speaker"));
};

module.exports.useYoutrainers = () => {
  return this.useYoumembers().filter(member => member.roles.find(role => role.type === "trainer"));
};

module.exports.useVmembers = () => {
  return members.filter(member => member.roles.find(role => role.category === "v"));
};

module.exports.useVspeakers = () => {
  return this.useVmembers().filter(member => member.roles.find(role => role.type === "speaker"));
};

module.exports.useVtrainers = () => {
  return this.useVmembers().filter(member => member.roles.find(role => role.type === "trainer"));
};